import { TableField } from "../../table-field";

export const fieldsPerfis: TableField[] = [
    { key: 'Id', label: 'Id', tdClass: 'align-middle', thClass: 'text-center', sortable: true },
    { key: 'Sigla', label: 'Sigla', tdClass: 'align-middle', thClass: 'text-center', sortable: true },
    { key: 'Descricao', label: 'Descricao', tdClass: 'align-middle', thClass: 'text-center', sortable: true },
    { key: 'Oculto', label: 'Oculto', tdClass: 'align-middle', thClass: 'text-center', sortable: true },
    { key: 'ControleInterno', label: 'Controle Interno', tdClass: 'align-middle', thClass: 'text-center', sortable: true },
    { key: "actions", label: "Ações", tdClass: ["align-middle", "col-actions"], thClass: "text-center", sortable: false }
]